import React from 'react';
import { Download, X, Zap } from 'lucide-react';

export const InstallModal = ({ pwa }) => {
  if (!pwa.showInstallModal || pwa.isInstalled) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm animate-in slide-in-from-bottom-4" data-testid="install-modal">
      <div className="bg-gray-900 border border-gray-700 rounded-xl p-5 shadow-2xl shadow-black/50">
        <button
          onClick={() => pwa.setShowInstallModal(false)}
          className="absolute top-3 right-3 text-gray-500 hover:text-white"
        >
          <X className="w-4 h-4" />
        </button>
        
        <div className="flex items-center gap-3 mb-3">
          <div className="w-12 h-12 bg-red-600 rounded-xl flex items-center justify-center">
            <Zap className="w-6 h-6 text-white" />
          </div>
          <div>
            <h3 className="font-bold text-white text-sm">Install BELLAJA App</h3>
            <p className="text-xs text-gray-400">Free - Works offline</p>
          </div>
        </div>
        
        <p className="text-xs text-gray-400 mb-4">
          Install our app for faster access, push notifications, and offline support.
        </p>
        
        <div className="flex gap-2">
          <button
            onClick={pwa.install}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white text-sm font-bold py-2.5 rounded-lg flex items-center justify-center gap-2 transition-colors"
            data-testid="install-app-btn"
          >
            <Download className="w-4 h-4" />
            Install
          </button>
          <button
            onClick={() => pwa.setShowInstallModal(false)}
            className="px-4 py-2.5 text-gray-400 hover:text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
};
